// extracted by mini-css-extract-plugin
export default {"dateTimeDisplay":"DateTimeDisplay_dateTimeDisplay__Y4zRG","time":"DateTimeDisplay_time__nEXR9"};